import {LoginViewStore} from "../view-store";
import React from "react";
import {MailOutlined, UserOutlined} from "@ant-design/icons";
import {Input, Radio, Typography} from "antd";
import {ContentWrapper} from "../ui/ContentWrapper";
import {useTranslation} from "react-i18next";
import {CentredTitle} from "../ui/CentredTitle";

export const InputMemberStep = () => {
    const loginMethod = LoginViewStore.useState(s => s.loginMethod);
    const value = LoginViewStore.useState(s => s.inputValue)
    const {t} = useTranslation(['login']);
    const inputProps = {
        size: 'large',
        placeholder: loginMethod === 'member' ? t(`sgsMember`) : t(`email`),
        prefix: loginMethod === 'member' ? <UserOutlined/> : <MailOutlined/>,
        value,
        onChange: e => {
            LoginViewStore.update(s => {
                s.inputValue = e.target.value.toLowerCase();
            })
        }
    }

    const radioProps = {
        onChange: () => {
            LoginViewStore.update(s => {
                s.loginMethod = s.loginMethod === 'member' ? 'email' : 'member';
            })
        },
        value: loginMethod,
        children: [
            <Radio.Button value="member">{t(`member`)}</Radio.Button>,
            <Radio.Button value="email">{t(`email`)}</Radio.Button>
        ]
    }
    return <ContentWrapper>
        <CentredTitle level={5}>{t('memberIdOrEmail')}</CentredTitle>
        <Radio.Group style={{paddingTop: 12}} {...radioProps}/>
        <Input {...inputProps}/>
    </ContentWrapper>
};
